module.exports = __webpack_public_path__ + "img/particle_motion_00073.0c21f42c.png";